var map = {
	"./views/base/base.module": [
		"Cvcy",
		0
	],
	"./views/buttons/buttons.module": [
		"Reju",
		3
	],
	"./views/chartjs/chartjs.module": [
		"Y+KY",
		6
	],
	"./views/dashboard/dashboard.module": [
		"6dU7",
		5
	],
	"./views/icons/icons.module": [
		"aPNi",
		2
	],
	"./views/notifications/notifications.module": [
		"KpDv",
		1
	],
	"./views/theme/theme.module": [
		"AgMk",
		4
	],
	"./views/widgets/widgets.module": [
		"XVX6",
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "zn8P";
module.exports = webpackAsyncContext;